<template>
  <div class="item">
    <div class="field-narrow">{{ index + 1 }}</div>
    <div class="field-medium">{{ item.name }}</div>
    <div class="field-narrow" v-if="item.id > 0">
      <button type="button" class="btn" @click="updateItem(true)" v-if="type === 0">
        {{ this.$t('join') }}
      </button>
      <div v-else>
        <button type="button" class="btn" @click="key()">
          {{ this.$t('key') }}
        </button>
        <button type="button" class="btn" @click="updateItem(false)">
          {{ this.$t('remove') }}
        </button>
      </div>
    </div>
    <div class="field-medium" v-else />
  </div>
</template>

<script>
import { useI18n } from 'vue-i18n';
import { inject } from 'vue';
import Swal from 'sweetalert2';
import { fetchGroup } from '../utils/api';
import { validateNumber } from '../utils/stringValid';

export default {
  props: {
    index: {
      type: Number,
      required: true,
    },
    item: {
      type: Object,
      required: true,
    },
    type: {
      type: Number,
      required: true,
    },
    mainId: {
      type: String,
      required: true,
    },
  },
  setup() {
    const { t } = useI18n();
    const apiBaseUrl = inject('apiBaseUrl');
    const url = 'module';
    return { t, apiBaseUrl, url };
  },
  data() {
    return {
      value: 0,
      alarm: 0,
    };
  },
  methods: {
    validateNumberValue(value) {
      if (validateNumber(value, 1, 100000)) {
        return true;
      }
      return false;
    },
    updateItem(add) {
      let title = this.$t('delete');
      let data = JSON.stringify({ mainId: this.mainId, subId: this.item.id });
      let url = '/group_delete/device_data';
      if (add) {
        title = this.$t('add');
        url = '/group_insert/device_data';
        data = JSON.stringify({
          mainId: this.mainId,
          subId: this.item.id,
        });
      }
      Swal.fire({
        icon: 'question',
        title: this.$t('confirm') + title,
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: this.$t('confirm'),
        cancelButtonText: this.$t('cancel'),
      }).then((result) => {
        let t = title;
        if (result.isConfirmed) {
          try {
            fetchGroup(this.t, `${this.apiBaseUrl}/${url}`, data, null).then((response) => {
              console.log(response);
              if (response.data.success) {
                if (add) {
                  console.log(this.item);
                  const i = this.item;
                  i.value = this.value;
                  i.uuid = response.data.result;
                  this.$emit('add-group', i);
                } else {
                  this.$emit('remove-group', this.item);
                }
              }
            });
          } catch (error) {
            t += this.$t('failure');
            console.error('Error fetching data:', error);
            Swal.fire({
              title: t,
              icon: 'error',
            });
          }
        }
      });
    },
    key() {
      Swal.fire({
        title: this.item.name,
        text: `${this.t('key')}:${this.item.uuid}`,
        icon: 'info',
      });
    },
  },
};
</script>

<style>
.item {
  display: flex;
  justify-content: space-between;
  font-weight: normal;
  padding: 10px;
}

.field-narrow {
  flex: 1;
  text-align: center;
}

.field-medium {
  flex: 2;
  text-align: center;
}

.field-medium-path {
  flex: 2;
  text-align: left;
}
</style>
